import { useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BannerCard } from "../../../components/common/bannerCard/BannerCard";
import { PageHeader } from "../../../components/common/pageHeader/PageHeader";
import { Pagination } from "../../../components/common/pagination/Pagination";
import { EmptySection } from "../../../components/sections/empty/Empty";
import { LoaderSection } from "../../../components/sections/loader/Loader";
import { URL_BANNER_CREATE } from "../../../mock/page_urls";
import { getBanner } from "../../../services/bannerSvc";
import Fancybox from "../../../utils/fancybox";
import { separateFormatter } from "../../../utils/separateFormatter";

export const BannersPage = () => {
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const {
    data: bannerData,
    isLoading: bannerIsLoading,
    refetch: refetchBanner
  } = useQuery(["getBanner", page], () => getBanner({
    params: {
      page,
    }
  }), {
    keepPreviousData: true,
  });

  const pageDetails = {
    title: "Bannerlar",
    desc: `Jami bannerlar soni: (${separateFormatter(bannerData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(URL_BANNER_CREATE),
      text: "Qo'shish",
      icon: "plus-square",
    }]
  };

  const totalItems = bannerData?.total_items || 0;
  const itemsPerPage = bannerData?.page_size || 8;


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  return (
      <div>
        <PageHeader pageDetails={pageDetails}/>
        {bannerIsLoading ? (
            <LoaderSection height={"50vh"}/>
        ) : bannerData?.data.length === 0 ? (
            <EmptySection height={"50vh"}/>
        ) : (
            <div className={"mb-10"}>
              <Fancybox>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-3 g-6 mb-10">
                  {bannerData?.data?.map((banner) => (
                      <BannerCard key={banner?.id} banner={banner} refetchBanner={refetchBanner}/>
                  ))}
                </div>
              </Fancybox>
              <Pagination
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
              />
            </div>
        )}
      </div>
  );
};